import { render, staticRenderFns } from "./InvoiceCustomFields.vue?vue&type=template&id=39981699&"
import script from "./InvoiceCustomFields.vue?vue&type=script&lang=js&"
export * from "./InvoiceCustomFields.vue?vue&type=script&lang=js&"
import style0 from "./InvoiceCustomFields.vue?vue&type=style&index=0&id=39981699&prod&lang=css&"
import style1 from "./InvoiceCustomFields.vue?vue&type=style&index=1&id=39981699&prod&module=true&lang=scss&"




function injectStyles (context) {
  
  this["$style"] = (style1.locals || style1)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports